import ConsultantCard from './ConsultantCard';
export default ConsultantCard;